// extracted by mini-css-extract-plugin
export default {"menu-icon":"Hamburger_menu-icon__HyD4r"};